import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CommonDeleteIconButton from '../../common/components/CommonDeleteIconButton';
import moveIcon from '../../assets/img/icons/move.svg';

function DraggablePhoto({
  photo,
  onDelete,
  className,
  showReorderHandle,
  disabled,
  photoIndex,
  onImageLoad,
  onImageError,
  style,
}) {
  const handleDelete = useCallback(() => {
    if (!disabled && onDelete) {
      onDelete(photo.mediaMetadataId || photoIndex);
    }
  }, [disabled, onDelete, photo.mediaMetadataId, photoIndex]);

  const displayUrl = photo.thumbnailUrl ? photo.thumbnailUrl : photo.fileUrl;

  const handleImageLoad = useCallback(
    (event) => {
      if (onImageLoad) {
        onImageLoad(event, photo);
      }
    },
    [onImageLoad, photo],
  );

  const handleImageError = useCallback(
    (event) => {
      if (onImageError) {
        onImageError(event, photo);
      }
    },
    [onImageError, photo],
  );

  if (!photo?.fileUrl) {
    return null;
  }

  return (
    <div
      className={classNames('draggable-photo-container', className, {
        'draggable-photo-container--disabled': disabled,
      })}
      style={style}
    >
      <img
        alt={`Vehicle ${photoIndex ? `${photoIndex + 1}` : ''}`}
        src={displayUrl}
        className="added-photo"
        loading="lazy"
        onLoad={handleImageLoad}
        onError={handleImageError}
        draggable={false}
      />
      <div className="draggable-photo-overlay" role="toolbar" aria-label="Photo actions">
        {showReorderHandle && (
          <button
            type="button"
            className="reorder-handle"
            aria-label="Drag to reorder photo"
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
              }
            }}
          >
            <img src={moveIcon} alt="" aria-hidden="true" />
          </button>
        )}
        <CommonDeleteIconButton
          className="delete-photo__button"
          handleClick={handleDelete}
          disabled={disabled}
          aria-label={`Delete photo ${photoIndex ? `${photoIndex + 1}` : ''}`}
        />
      </div>
    </div>
  );
}

DraggablePhoto.propTypes = {
  photo: PropTypes.shape({
    fileUrl: PropTypes.string.isRequired,
    mediaMetadataId: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  onDelete: PropTypes.func.isRequired,
  className: PropTypes.string,
  showReorderHandle: PropTypes.bool,
  disabled: PropTypes.bool,
  photoIndex: PropTypes.number,
  onImageLoad: PropTypes.func,
  onImageError: PropTypes.func,
};

DraggablePhoto.defaultProps = {
  className: '',
  showReorderHandle: true,
  disabled: false,
  photoIndex: null,
  onImageLoad: null,
  onImageError: null,
};

export default DraggablePhoto;
